/* eslint-disable max-len */
import { IconProps } from './types';

export const ReportsListIcon = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20.97 19.472'>
    <g transform='translate(-2.25 -3.375)'>
      <path
        d='M18.507,12.339l-4.081,6.243A2.223,2.223,0,0,1,14.932,20a2.246,2.246,0,0,1-4.492,0,2.461,2.461,0,0,1,.037-.416l-2.7-1.568a2.232,2.232,0,0,1-1.558.627,2.259,2.259,0,0,1-1.1-.29L2.25,21.039v2.677a2,2,0,0,0,2,2H21.221a2,2,0,0,0,2-2V13.766l-2.742-1.82a2.245,2.245,0,0,1-1.97.393Z'
        transform='translate(0 -2.867)'
        fill='#fff'
        {...props}
      />
      <path
        d='M6.228,11.284A2.247,2.247,0,0,1,8.474,13.53c0,.1-.009.2-.019.29l2.812,1.572a2.226,2.226,0,0,1,1.423-.505,2.35,2.35,0,0,1,.487.051L17.267,8.6a2.223,2.223,0,0,1-.416-1.3,2.246,2.246,0,1,1,4.492,0,2.441,2.441,0,0,1-.061.529l1.933,1.292V5.373a2,2,0,0,0-2-2H4.248a2,2,0,0,0-2,2V16.1l1.872-1.792a2.246,2.246,0,0,1,2.106-3.028Z'
        fill='#fff'
        {...props}
      />
    </g>
  </svg>
);

export const ReportIcon = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 31.028 31.013'>
    <g transform='translate(-3.368 -3.375)'>
      <path
        d='M6.514,13.508A6.847,6.847,0,0,1,9.757,7.626a.241.241,0,0,0-.127-.447h0a5.757,5.757,0,0,0-5.524,5.2,1.059,1.059,0,0,0-.738,1.111,1.016,1.016,0,0,0,.805,1.1,6.579,6.579,0,0,0,4.563,4.809h0a.325.325,0,0,0,.283-.559A7.429,7.429,0,0,1,6.514,13.508Z'
        transform='translate(0 0.229)'
        fill='#fff'
        {...props}
      />
      <path
        d='M33.069,7.46c-.075-.2-.157-.388-.239-.574a7.648,7.648,0,0,0-1.618-2.4,3.679,3.679,0,0,0-2.594-1.111,3.408,3.408,0,0,0-1.923.582A26.59,26.59,0,0,1,15.214,7.386c-3.109,0-2.937.015-2.937.015A6.99,6.99,0,0,0,11.5,19.7c.9.753,1.759.656,1.573,1.655S11.4,28.626,11.211,29.93s-.216,2.05.3,2.684,3.69,1.774,5.069,1.774,1.029-.649,1.029-3.265-.693-9.818,1.23-9.818c3.6,0,5.48,1.29,8.3,2.363a4,4,0,0,0,1.5.35,3.677,3.677,0,0,0,2.587-1.357,7.725,7.725,0,0,0,1.618-2.4c.082-.194.164-.388.246-.6a17.409,17.409,0,0,0,1.021-6.106A17.419,17.419,0,0,0,33.069,7.46Zm-1.983,11.7c-.477,1.17-1.312,2.1-2.005,2.1s-1.327-.932-1.8-2.1A15.373,15.373,0,0,1,26.36,13.6a15.431,15.431,0,0,1,.917-5.584c.477-1.163,1.111-1.864,1.8-1.864s1.513.708,2,1.864a15.02,15.02,0,0,1,.015,11.153Z'
        transform='translate(0.291)'
        fill='#fff'
        {...props}
      />
    </g>
  </svg>
);
